import { paymentMethodsKeys } from 'constants/general';
import {
  orderStatusesToShowInProgressBarByOrderType,
  StatusesIdToLabelDefaults,
  StatusesIdToLabelSpecial,
  StatusesIdToLabelAborted,
} from 'modules/orders/constants';

export const getOrderStatusesDefaultTemplate = (
  onlinePaymentCardKey,
  optionalPaymentMethodKey,
  isSelfInsuranceOrder = false,
) => {
  let orderStatusToShowInProgressBarArr = [];
  if (onlinePaymentCardKey || optionalPaymentMethodKey === paymentMethodsKeys.vezeetaCash) {
    if (isSelfInsuranceOrder) {
      orderStatusToShowInProgressBarArr = [
        ...orderStatusesToShowInProgressBarByOrderType.loyaltySelfInsurance,
      ];
    } else {
      orderStatusToShowInProgressBarArr = [...orderStatusesToShowInProgressBarByOrderType.loyalty];
    }
  } else if (isSelfInsuranceOrder) {
    orderStatusToShowInProgressBarArr = [
      ...orderStatusesToShowInProgressBarByOrderType.defaultSelfInsurance,
    ];
  } else {
    orderStatusToShowInProgressBarArr = [...orderStatusesToShowInProgressBarByOrderType.default];
  }
  return orderStatusToShowInProgressBarArr;
};

export const getOrderStatusesTobeDisplayedInProgressBar = orderLogs => {
  const orderLogsStatusArr = [];
  orderLogs?.forEach(log => {
    // Following condition to exclude any state before 14: New Order
    if (
      (StatusesIdToLabelDefaults[log.orderStateTypeId] ||
        StatusesIdToLabelSpecial[log.orderStateTypeId] ||
        StatusesIdToLabelAborted[log.orderStateTypeId]) &&
      !orderLogsStatusArr.includes(log.orderStateTypeId)
    ) {
      orderLogsStatusArr.push(log.orderStateTypeId);
    }
  });
  return orderLogsStatusArr;
};

export const getStatusName = statusId => {
  let statusName = '';
  statusName =
    StatusesIdToLabelDefaults[statusId] ||
    StatusesIdToLabelAborted[statusId] ||
    StatusesIdToLabelSpecial[statusId] ||
    '';
  return statusName;
};

export const getStatusColor = (statusId, orderLogsStatusList) => {
  let statusColor = '';
  const logs = orderLogsStatusList || [];
  if (logs.includes(statusId)) {
    if (StatusesIdToLabelAborted[statusId]) {
      statusColor = '#DB3226';
    } else {
      statusColor = '#31A636';
    }
  }
  return statusColor;
};

/** Full template sequence; coloring still comes from logs via mapProgressBarStepsToStyled. */
export const getSelfInsuranceProgressBarSteps = template => [...template];

/**
 * Merge log history with remaining template steps after the newest log state that appears in the template.
 * If no log state matches the template, append the full template after all logs.
 */
export const getLegacyProgressBarSteps = (template, orderLogsStatusList) => {
  const logs = orderLogsStatusList;
  if (!logs.length) {
    return [];
  }
  for (let index = logs.length - 1; index >= 0; index -= 1) {
    const statusAtIndex = logs[index];
    if (template.includes(statusAtIndex)) {
      const templateIndex = template.findIndex(val => val === statusAtIndex);
      return [...logs, ...template.slice(templateIndex + 1)];
    }
    if (index === 0) {
      return [...logs, ...template];
    }
  }
  return [];
};
// Todo: heba don't understand
export const mapProgressBarStepsToStyled = (steps, orderLogsStatusList, currentOrderStateTypeId) =>
  steps.map(step => ({
    orderStatusName: getStatusName(step),
    orderStatusColor: getStatusColor(step, orderLogsStatusList, currentOrderStateTypeId),
    orderStatus: step,
  }));

export const buildMappedOrderProgressBar = (
  orderStatusesDefaultTemplate,
  orderLogsStatusList,
  isSelfInsuranceOrder,
  currentOrderStateTypeId,
) => {
  const steps = isSelfInsuranceOrder
    ? getSelfInsuranceProgressBarSteps(orderStatusesDefaultTemplate)
    : getLegacyProgressBarSteps(orderStatusesDefaultTemplate, orderLogsStatusList);
  return mapProgressBarStepsToStyled(steps, orderLogsStatusList, currentOrderStateTypeId);
};
